import React from 'react';
import parse from 'html-react-parser';

import './booking-lookup-section.scss';
import { useOSBContentFragment } from '../../../../hooks/owners-osb/aem-content-util/use-osb-content-fragment';
import { FMButton } from '@own/fds-react';
import { OSBContentData } from '../../../../models/osb-model/osb-content-data';

export interface BookingLookupSectionProps {
    onTrigger?: () => void;
    className?: string;
}

const BookingLookupSection: React.FC<BookingLookupSectionProps> = ({
    onTrigger,
    className = '',
}) => {
    const osbContentData = useOSBContentFragment(
        'common/osb-v3',
        'vehicle-step'
    ) as OSBContentData | undefined | null;
    const isLoading = typeof osbContentData === 'undefined';
    const descriptionHtml = (
        osbContentData?.retrieveBookingDescription || ''
    ).toString();
    const buttonLabel = osbContentData?.retrieveBookingButtonLabel;

    const handleClick = (
        e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
    ) => {
        if (onTrigger) {
            e.preventDefault();
            onTrigger();
        }
    };

    return (
        <div
            className={`osb-v3-booking-lookup-section ${className}`}
            data-testid="booking-lookup-section"
            aria-labelledby="booking-lookup-desc"
        >
            {isLoading ? (
                <>
                    <div
                        className="booking-lookup-desc booking-lookup-desc--skeleton"
                        aria-hidden="true"
                    >
                        <div className="skeleton-line skeleton-line--lg" />
                    </div>

                    <div className="booking-lookup-cta-section">
                        <div
                            className="booking-cta-btn booking-cta-btn--skeleton"
                            aria-hidden="true"
                        >
                            <div className="skeleton-button" />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div
                        id="booking-lookup-desc"
                        className="booking-lookup-desc"
                    >
                        {descriptionHtml ? parse(descriptionHtml) : null}
                    </div>
                    <div className="booking-lookup-cta-section">
                        <div className="booking-cta-btn">
                            <FMButton
                                data-testid="booking-lookup-cta"
                                href=""
                                label={buttonLabel}
                                type="primary"
                                theme="light"
                                onClick={handleClick}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default BookingLookupSection;
